import * as types from '../constants/ActionTypes';

const speech = {
  SPEECH_SOUND_START: 'SPEECH_SOUND_START',
  SPEECH_SOUND_END: 'SPEECH_SOUND_END',
  SPEECH_START: 'SPEECH_START',
  SPEECH_STOP: 'SPEECH_STOP',
  SPEECH_REQUEST: 'SPEECH_REQUEST',
  SPEECH_RESET: 'SPEECH_RESET',
  SPEECH_ERROR: 'SPEECH_ERROR',
};

const initialState = {
  isRecording: false,
  query: '',
  status: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SPEECH_START_RECORDING:
      return Object.assign({}, state, { isRecording: true, query: '', status: speech.SPEECH_START });
    case types.SPEECH_END_RECORDING:
      return Object.assign({}, state, { isRecording: false, status: speech.SPEECH_STOP });
    case types.SPEECH_RECOGNITION_REQUEST:
      return Object.assign({}, state, { query: action.payload, status: speech.SPEECH_REQUEST });
    case types.RESET_SPEECH_QUERY:
      return Object.assign({}, state, { query: '', status: speech.SPEECH_RESET });
    case types.ERROR_SPEECH_RECORDING:
      return Object.assign({}, state, { status: speech.SPEECH_ERROR, errorMessage: action.payload });
    case types.SOUND_START_RECORDING:
      return Object.assign({}, state, { status: speech.SPEECH_SOUND_START });
    case types.SOUND_END_RECORDING:
      return Object.assign({}, state, { status: speech.SPEECH_SOUND_END });
    default:
      return state;
  }
}
